"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountPostSchema = void 0;
const yup_1 = require("yup");
const DBReferenceSchema_1 = require("../DBReferenceSchema");
const AccountPostSchema = (0, yup_1.object)().shape({
    organisation: DBReferenceSchema_1.DBReferenceSchema,
    name: (0, yup_1.string)().min(3).required(),
    domain: (0, yup_1.string)().min(3).required(),
    timezone: (0, yup_1.string)().required(),
    countryCode: (0, yup_1.string)().required(),
    address: (0, yup_1.object)().shape({
        line1: (0, yup_1.string)().required(),
        line2: (0, yup_1.string)().required(),
        level1: (0, yup_1.string)().required(),
        level2: (0, yup_1.string)().required(),
        postalCode: (0, yup_1.string)().required(),
        country: (0, yup_1.string)().required(),
    }),
    ttsLanguage: (0, yup_1.string)().required(),
    asrLanguage: (0, yup_1.string)().required(),
});
exports.AccountPostSchema = AccountPostSchema;
